// Native smooth scrolling. (Replaced Lenis, which was locking page scroll.)
export default function SmoothScroll({ children }) {
  return children;
}
